import type { MediaUrlEndpoints } from './types';

const allowedOrigins = [
  'https://admin.fantaz.com',
  'https://admin.fantazstaging-dev.com',
  'https://admin.fantazsandbox-dev.com',
];

export const getApiUrlEndpoints = (): MediaUrlEndpoints => {
  let baseurl = window.location.origin;
  if (!allowedOrigins.includes(baseurl)) {
    baseurl = 'https://admin.fantazsandbox-dev.com';
  }
  return {
    getFiles: `${baseurl}/cms/api/upload/files`,
    upload: `${baseurl}/cms/api/upload`,
  };
};

export const isIdValid = (id: string) => {
  return /^[a-zA-Z0-9_]+$/.test(id);
};

export const uniqueId = () => {
  return Math.random().toString(36).substring(2, 9);
};
